














import Vue from "vue";
import * as routes from "@/router/routes";

import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import StocksConfigMainTable from "./StocksConfigMainTable.vue";
import {
    FetchInstallationsRollsConfigurationCommand,
    FetchInstallationsRollsConfigurationReqData,
    GetFetchInstallationsRollsConfigurationReqData,
} from "@/model/communication/security/FetchInstallationsRollsConfigurationCommand";

import { dataTableItemsPerPage } from "@/utility/Constants";

import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { FetchInstallationsRollsConfigurationResData } from "@/model/communication/security/FetchInstallationsRollsConfigurationResData";

export default Vue.extend({
    components: {
        StandardPage,
        StocksConfigMainTable,
    },
    data() {
        return {
            StocksConfigMainTable,
            routes,
            loading: false,
            totalsLoading: false,
            reqData: null,
            installations: [],
            paginatedTotalItems: null,
            dataTableItemsPerPage,
            metricsTotals: null,
            lastSort: "",
            lastDesc: null,
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.reqData = request;
                this.loading = true;
                var response: FetchInstallationsRollsConfigurationResData = await new FetchInstallationsRollsConfigurationCommand(
                    GetFetchInstallationsRollsConfigurationReqData(request)
                ).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installationsList;
                    this.paginatedTotalItems = response.totalInstallationsCount;
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationsRollsConfiguration request ", e);
            }
            this.loading = false;
        },

        async sendRequestAndBackToTheFirstPage(request) {
            this.$refs.standardPage.backToTheFirst();
            this.sendRequest(request);
        },
    },
    mounted() {
        if (this.$route.query.reqData != null && this.$route.query.reqData != undefined) {
            this.reqData = JSON.parse(atob(this.$route.query.reqData));
        } else {
            this.reqData = new FetchInstallationsRollsConfigurationReqData();
            this.reqData.queryLimit = this.dataTableItemsPerPage[0];
        }
    },
});
